<template>
  <div
    id="account-menu"
    class="account-menu"
  >
    <icon-button
      round
      :title="$t('menu.account')"
      @click="open = true"
    >
      <i-account :title="$t('menu.account')"></i-account>
    </icon-button>
    <drop-board
      position="bottom"
      v-show="open"
    >
      <div class="account-number">№ {{ $store.state.user.id }}</div>
      <m-button
        dark
        class="list-item"
        @click="click('bets')"
      >
        <i-clover
          class="list-item-icon"
          :title="null"
        ></i-clover>
        <span class="list-item-name">{{ $t('menu.bets') }}</span>
      </m-button>
      <!--m-button
        dark
        class="list-item"
        @click="click('payments/withdrawal')"
      >
        <i-credit-card
          class="list-item-icon"
          :title="null"
        ></i-credit-card>
        <span class="list-item-name">{{ $t('menu.payments') }}</span>
      </m-button-->
      <m-button
        dark
        class="list-item"
        @click="click('profile')"
      >
        <i-account-details
          class="list-item-icon"
          :title="null"
        ></i-account-details>
        <span class="list-item-name">{{ $t('menu.profile') }}</span>
      </m-button>
      <!--m-button
        dark
        class="list-item"
        @click="click('bonuses')"
      >
        <i-wallet-giftcard
          class="list-item-icon"
          :title="null"
        ></i-wallet-giftcard>
        <span class="list-item-name">{{ $t('menu.bonuses') }}</span>
      </m-button-->
      <m-button
        dark
        class="list-item"
        @click="click('logout')"
      >
        <i-exit-to-app
          class="list-item-icon"
          :title="null"
        ></i-exit-to-app>
        <span class="list-item-name">{{ $t('menu.log-out') }}</span>
      </m-button>
    </drop-board>
  </div>
</template>

<script>
import IAccount from 'vue-material-design-icons/AccountCircle'
import IClover from 'vue-material-design-icons/Clover'
import ICreditCard from 'vue-material-design-icons/CreditCard'
import IAccountDetails from 'vue-material-design-icons/AccountDetails'
import IWalletGiftcard from 'vue-material-design-icons/WalletGiftcard'
import IExitToApp from 'vue-material-design-icons/ExitToApp'
import MButton from '@/components/buttons/MButton'
import IconButton from '@/components/buttons/IconButton'
import DropBoard from '@/components/DropBoard'

export default {
  components: {
    DropBoard,
    MButton,
    IconButton,

    IAccount,
    IClover,
    ICreditCard,
    IAccountDetails,
    IWalletGiftcard,
    IExitToApp
  },
  data () {
    return {
      open: false,
      updateInterval: null
    }
  },
  mounted () {
    document.addEventListener('click', this.handleDocumentClick.bind(this))

    this.getActualAccountData()
    this.updateInterval = setInterval(this.getActualAccountData.bind(this), 5000)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleDocumentClick)
    clearInterval(this.updateInterval)
  },
  methods: {
    handleDocumentClick (event) {
      let target = event.target || event.srcElement
      if (!target.closest('#account-menu')) {
        this.open = false
      }
    },
    click (action) {
      this.open = false
      if (action === 'logout') {
        this.$store.dispatch('setToken', null)
        this.$store.dispatch('setUser', null)
        this.$router.push('/')
        document.querySelector('#page-right-scroll').scrollTop = 0
      } else {
        this.$router.push(`/account/${action}`)
      }
    },
    getActualAccountData () {
      if (!this.$store.isUserLoggedIn) return
      this.$store.dispatch('account/GET_ACTUAL')
    }
  }
}
</script>

<style scoped>
.account-menu { border-radius: 20px; height: 40px; margin: 5px 10px; position: relative; width: 40px; }
.icon-button { color: #2c3e50; font-size: 24px; }

.drop-board { color: #2c3e50; padding-bottom: 5px; right: 0; }
.drop-board:before { right: 15px; }
.account-number { border-bottom: 1px solid rgba(0, 0, 0, .05); height: 30px; line-height: 30px; text-align: center; }
.list-item { align-items: center; display: flex; height: 40px; line-height: 40px; padding-right: 12px; }
.list-item-icon { font-size: 18px; margin: 0 10px 0 12px; }
</style>



// WEBPACK FOOTER //
// src/components/header/AccountMenu.vue